import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import moment from "moment";
import { Grid, Image, Table, Icon } from 'semantic-ui-react'
import nav_img from "../assets/home/nav_img.png";
import { useTranslation } from "react-i18next";
import { StarButton, Loading } from '../components'
import { useSelector, useDispatch } from 'react-redux'
import { getSingleWinners } from '../store/OrderRedux'
import { Config } from '../common'


const Leaderboard = (props) => {
    const { match } = props;
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch()
    const token = useSelector((state) => state.auth.token)
    const userDetails = useSelector((state) => state.user.userDetails)
    const winnerDetails = useSelector((state) => state.order.winnerDetails)
    const isFetching = useSelector((state) => state.order.isFetching)

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    useEffect(() => {
        if (match.params.id) {
            dispatch(getSingleWinners({ triviaId: match.params.id, token }))
        }
    }, [match]);

    useEffect(() => {
        if (winnerDetails) {
            let newDate = moment.utc(Config.localUtc()) - moment.utc(winnerDetails?.trivia?.resultDate)
            if (newDate < 0) {
                history.push('/')
            }
        }
    }, [winnerDetails]);


    if (isFetching) {
        return <Loading />
    }

    let winner = (winnerDetails?.trivia?.winnerUsers ? winnerDetails?.trivia?.winnerUsers : []).find((x) => x == userDetails?._id)
    return (
        <div className="container-flud">
            <div className={"Leaderboard_sec " + (winner ? "activeBg" : "")}>
                <div className="leaderboardBG"><Image verticalAlign='middle' className="leaderboardImg" src={userDetails?.profile?.profileURL ? userDetails?.profile?.profileURL : nav_img} size='tiny' circular /></div>
                <h5>{userDetails?.profile?.name}</h5>
                {winner && (<>
                    <h4>Congratulations</h4>
                    <p>Kudos to you ! You’re amazing and you are one of <span>Top #{winnerDetails?.trivia?.winnerPlayers?.length}</span> </p>
                    <p>Contest name : <span>{winnerDetails?.trivia?.basicDetails?.title}</span> </p>
                    <h3><span>Other {t("leaderbord.amazing")}</span>{t("leaderbord.winners")}</h3>
                </>)}

                {!winner && (<>
                    <h4>Amazing Effort</h4>
                    <p>Great effort from your end ! You can enter other contest </p>
                    <p>Contest name : <span>{winnerDetails?.trivia?.basicDetails?.title}</span> </p>
                    <h3><span>Other {t("leaderbord.amazing")}</span>{t("leaderbord.winners")}</h3>
                </>)}
            </div>
            <div className="leaderboard_bg">
                <div className="leader_sec">
                    <Table>
                        <Table.Row>
                            <Table.HeaderCell width={4} ><h4>Name </h4></Table.HeaderCell>
                            <Table.HeaderCell width={4} ><h3>Rank </h3></Table.HeaderCell>
                            <Table.HeaderCell width={4} ><h3>Location </h3></Table.HeaderCell>
                            <Table.HeaderCell width={4} ><h5>Time</h5></Table.HeaderCell>
                        </Table.Row>
                    </Table>
                </div>
                <div className="text"></div>
                <div className="scrolls-y" style={{ height: 400 }}>
                    {winnerDetails.data ? winnerDetails.data.map((item, key) => <div key={key} className="amounts">
                        <Grid>
                            <Grid.Row >
                                <Grid.Column mobile={8} tablet={8} computer={4}>
                                    <div className="username">
                                        <Image className="ninten_img" src={item?.user?.profile?.profileURL ? item?.user?.profile?.profileURL : nav_img} avatar />
                                        <span>{item.userName}</span>
                                    </div>
                                </Grid.Column>
                                <Grid.Column mobile={8} tablet={8} computer={4}>
                                    <h3>Top #{winnerDetails?.count}</h3>
                                </Grid.Column>
                                <Grid.Column mobile={8} tablet={8} computer={4}>
                                    {/* <h5> — </h5> */}
                                </Grid.Column>
                                <Grid.Column mobile={8} tablet={8} computer={4}>
                                    <h4>{Config.parseDuration(item.timeTaken)}</h4>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>) : null}
                </div>
            </div>
            <Grid centered>
                <Grid.Row >
                    <div className="return">
                        <StarButton background={'mainBg'} width="350px" title={t("fourscreen.btn")} onClickAction={() => history.push('/')} />
                    </div>
                </Grid.Row>
            </Grid>

        </div>
    );

};

export default Leaderboard;
